import { Component } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import classNames from 'classnames';
import ChatFB from '../../assets/images/ChatFB';
import ChatLINE from '../../assets/images/ChatLINE';
import Badge from './Badge';
import defaultUser from '../../assets/images/svg/default-customer-light.svg';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  icon: {
    marginLeft: '-20px',
    zIndex: 2,
  },
}));

const PlatformIcon = props => {
  const classes = useStyles();
  const small = props.small ? '0 0 24 24' : '0 0 20 20';
  return (
    <SvgIcon
      viewBox={small}
      className={props.iconStyle ? props.iconStyle : classes.icon}
    >
      {props.platform === 'facebook' ? <ChatFB /> : <ChatLINE />}
    </SvgIcon>
  );
};

class ImageDisplay extends Component {
  constructor(props) {
    super(props);
    this.image = new Image();
    this.state = {
      src: defaultUser,
    };
  }

  componentDidMount() {
    const { src } = this.props;
    this.image.onload = () => {
      this.setState({ src: this.image.currentSrc });
    };
    this.image.src = src;
  }

  componentDidUpdate(prevProps) {
    const { src } = this.props;
    if (src && prevProps.src !== src && src !== defaultUser) {
      this.image.onload = () => {
        this.setState({ src: this.image.currentSrc });
      };
      this.image.src = src;
    }
  }

  componentWillUnmount() {
    this.image.onload = () => {};
  }

  renderImage() {
    return (
      <>
        {this.props.isBot && (
          <div className="bot-mask">
            <div className="bot-icon" />
          </div>
        )}
        <img
          role="presentation"
          alt={this.props.alt}
          style={this.props.style}
          className={classNames([this.props.className])}
          onClick={this.props.onClick}
          src={this.state.src}
          width={this.props.width}
          height={this.props.height}
        />
      </>
    );
  }

  render() {
    return (
      <>
        {this.props.platform ? (
          <span
            style={{
              display: 'flex',
              position: 'relative',
            }}
          >
            {this.renderImage()}
            <PlatformIcon
              platform={this.props.platform}
              iconStyle={this.props.iconStyle}
              small={this.props.small}
            />
          </span>
        ) : (
          <Badge
            className={this.props.badgeClass}
            badgeColor={this.props.badgeColor}
            invisible={!this.props.badgeShow}
            variant="dot"
          >
            {this.renderImage()}
          </Badge>
        )}
      </>
    );
  }
}

ImageDisplay.defaultProps = {
  badgeClass: undefined,
};

ImageDisplay.propTypes = {
  badgeClass: PropTypes.string,
};

export default ImageDisplay;
